"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateKnowledge = void 0;
var UpdatedUserImpulse_1 = require("./UpdatedUserImpulse");
var UpdatedTenantImpulse_1 = require("./UpdatedTenantImpulse");
var UpdatedBehaviourImpulse_1 = require("./UpdatedBehaviourImpulse");
var UpdatedApiKeyImpulse_1 = require("./UpdatedApiKeyImpulse");
var UpdatedSkillImpulse_1 = require("./UpdatedSkillImpulse");
var UpdatedCodeImpulse_1 = require("./UpdatedCodeImpulse");
var UpdatedRoleImpulse_1 = require("./UpdatedRoleImpulse");
var UpdatedIntentImpulse_1 = require("./UpdatedIntentImpulse");
var UpdatedStatementImpulse_1 = require("./UpdatedStatementImpulse");
var UpdatedFulfilmentImpulse_1 = require("./UpdatedFulfilmentImpulse");
var UpdatedSkillProvisionImpulse_1 = require("./UpdatedSkillProvisionImpulse");
var UpdatedIdentityImpulse_1 = require("./UpdatedIdentityImpulse");
var UpdatedPromptImpulse_1 = require("./UpdatedPromptImpulse");
var UpdateKnowledge = /** @class */ (function (_super) {
    __extends(UpdateKnowledge, _super);
    function UpdateKnowledge() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "UpdateKnowledge";
        /**
         * updates a list of identities with the given specifications
         */
        _this.identities = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new UpdatedIdentityImpulse_1.UpdatedIdentityImpulse();
            config(entity);
            return "identities(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * updates a list of tenants with the given specifications
         */
        _this.tenants = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new UpdatedTenantImpulse_1.UpdatedTenantImpulse();
            config(entity);
            return "tenants(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * updates a list of users with the given specifications
         */
        _this.users = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new UpdatedUserImpulse_1.UpdatedUserImpulse();
            config(entity);
            return "users(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * updates a list of api keys with the given specifications
         */
        _this.apiKeys = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new UpdatedApiKeyImpulse_1.UpdatedApiKeyImpulse();
            config(entity);
            return "apiKeys(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * updates a list of roles with the given specifications
         */
        _this.roles = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new UpdatedRoleImpulse_1.UpdatedRoleImpulse();
            config(entity);
            return "roles(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * updates a list of intents with the given specifications
         */
        _this.intents = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new UpdatedIntentImpulse_1.UpdatedIntentImpulse();
            config(entity);
            return "intents(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * updates a list of prompts with the given specifications
         */
        _this.prompts = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new UpdatedPromptImpulse_1.UpdatedPromptImpulse();
            config(entity);
            return "prompts(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * updates a list of statements with the given specifications
         */
        _this.statements = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new UpdatedStatementImpulse_1.UpdatedStatementImpulse();
            config(entity);
            return "statements(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * updates a list of fulfilments with the given specifications
         */
        _this.fulfilments = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new UpdatedFulfilmentImpulse_1.UpdatedFulfilmentImpulse();
            config(entity);
            return "fulfilments(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * updates a list of behaviours with the given specifications
         */
        _this.behaviours = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new UpdatedBehaviourImpulse_1.UpdatedBehaviourImpulse();
            config(entity);
            return "behaviours(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * updates a list of codes with the given specifications
         */
        _this.codes = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new UpdatedCodeImpulse_1.UpdatedCodeImpulse();
            config(entity);
            return "codes(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * updates a list of skills with the given specifications
         */
        _this.skills = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new UpdatedSkillImpulse_1.UpdatedSkillImpulse();
            config(entity);
            return "skills(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * updates a list of skill provisions with the given specifications
         */
        _this.skillProvisions = function (impulses, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulses", impulses);
            var entity = new UpdatedSkillProvisionImpulse_1.UpdatedSkillProvisionImpulse();
            config(entity);
            return "skillProvisions(impulses:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return UpdateKnowledge;
}(Array));
exports.UpdateKnowledge = UpdateKnowledge;
//# sourceMappingURL=UpdateKnowledge.js.map